export const copyTextFromElement = (selector, container) => {
  const field = document.querySelector(selector);
  return copyText(field.textContent.toString(), container);
};

export const copyText = (text, container = document.body) => {
  try {
    let textArea = document.createElement('textarea');
    textArea.value = text;
    container.appendChild(textArea);
    textArea.select();
    textArea.focus();
    document.execCommand('copy');
    textArea.remove();
    window.getSelection().removeAllRanges();
    return true;
  } catch (e){
    return false;
  }
};
